export default __webpack_public_path__ + "designsystem/assets/fonts/icons/gov-complex-icons.woff2";